// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__6ii+g"};